var _defs, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5ZielpublikumAusgewahltplatzen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#707070;}.c{fill:#b30200;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M487.281,266.929a5,5,0,1,1,5-5A5.006,5.006,0,0,1,487.281,266.929Zm0-6a1,1,0,1,0,1,1A1,1,0,0,0,487.281,260.929Zm0,12a11,11,0,1,1,11-11A11.013,11.013,0,0,1,487.281,272.929Zm0-18a7,7,0,1,0,7,7A7.008,7.008,0,0,0,487.281,254.929Zm0,24a17,17,0,1,1,17-17A17.019,17.019,0,0,1,487.281,278.929Zm0-30a13,13,0,1,0,13,13A13.014,13.014,0,0,0,487.281,248.929Z",
    transform: "translate(-447.281 -188.93)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M479.281,216.929a5,5,0,1,1,5-5A5.006,5.006,0,0,1,479.281,216.929Zm0-6a1,1,0,1,0,1,1A1,1,0,0,0,479.281,210.929Zm0,12a11,11,0,1,1,11-11A11.013,11.013,0,0,1,479.281,222.929Zm0-18a7,7,0,1,0,7,7A7.008,7.008,0,0,0,479.281,204.929Zm0,24a17,17,0,1,1,17-17A17.019,17.019,0,0,1,479.281,228.929Zm0-30a13,13,0,1,0,13,13A13.014,13.014,0,0,0,479.281,198.929Zm40.653,34.181a5,5,0,1,1,5-5A5.006,5.006,0,0,1,519.934,233.11Zm0-6a1,1,0,1,0,1,1A1,1,0,0,0,519.934,227.11Zm0,12a11,11,0,1,1,11-11A11.012,11.012,0,0,1,519.934,239.11Zm0-18a7,7,0,1,0,7,7A7.008,7.008,0,0,0,519.934,221.11Z",
    transform: "translate(-447.281 -188.93)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5ZielpublikumAusgewahltplatzen);
export default __webpack_public_path__ + "static/media/5_zielpublikum_ausgewahltplatzen.62bb447cca724fa889836cf2e92e9c85.svg";
export { ForwardRef as ReactComponent };